import { ButtonBase, styled } from '@ori-ui/mui';

export const SearchIconRoot = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.grey[700],
  display: 'none',
  fontSize: '3rem',

  marginRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    display: 'inline-flex',
    marginRight: 0,
  },
}));
